/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { createEmptyStateResource, StateResource } from '@common/tech-shared';

import { Component, computed, input, InputSignal, output, OutputEmitterRef, Signal } from '@angular/core';
import { Resource } from '@ngxp/rest';
import { ButtonComponent, ButtonVariants, IconVariants, TooltipDirective } from '@ods/system';

@Component({
  selector: 'odc-download-button',
  imports: [ButtonComponent, TooltipDirective],
  template: `<ods-button
    [dataTestId]="dataTestId()"
    icon="save"
    [iconConfig]="{ size: 'small', fill: fill() }"
    [variant]="variant()"
    size="fit"
    spinnerSize="small"
    [isLoading]="isLoading()"
    [disabled]="disabled()"
    [tooltip]="tooltipText()"
    tooltipAriaType="aria-label"
    (clicked)="clicked.emit($event)"
  />`,
})
export class DownloadButtonComponent {
  public readonly dataTestId: InputSignal<string> = input.required<string>();
  public readonly tooltipText: InputSignal<string> = input<string>('');
  public readonly disabled: InputSignal<boolean> = input<boolean>(false);
  public readonly variant: InputSignal<ButtonVariants['variant']> = input.required<ButtonVariants['variant']>();
  public readonly fill: InputSignal<IconVariants['fill']> = input<IconVariants['fill']>();
  public readonly stateResource: InputSignal<StateResource<Resource>> =
    input<StateResource<Resource>>(createEmptyStateResource());

  public readonly clicked: OutputEmitterRef<MouseEvent> = output<MouseEvent>();

  public readonly isLoading: Signal<boolean> = computed(() => this.stateResource().loading || this.stateResource().reload);
}
